import axios from 'axios';
import { api_labelflow } from '../../../../config.jsx';

// Re-export the existing trained-model download call so the hub owns a single api surface.
export { downloadTrainedModelAPI } from '../../modelManagement/api/modelManagementAPI';

// List all public models for the hub (optionally narrowed by model_type on the server).
export const getPublicModelsAPI = (params) =>
  axios.get(`${api_labelflow}/model_management/get_public_models`, {
    params: params || {},
    timeout: 15000,
  });

// Bump a model's download counter after a successful download.
export const incrementDownloadAPI = (modelId) => {
  const body = new URLSearchParams();
  body.append('model_id', modelId);
  return axios.post(`${api_labelflow}/model_management/increment_download`, body, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
};
